import { TPgPaymentDetails } from 'services/api/paymentGateway/types';
import { roundTo } from '../utils';

/** Disputes that ended in favour of the merchant: the money is not at risk any more. */
const CLOSED_DISPUTE_STATUSES = ['WON', 'REVERSED'];

/** Currency in which the customer was charged (and in which refunds are made). */
export const chargedCurrencyOf = (payment: TPgPaymentDetails): string =>
	payment.chargedCurrency ?? payment.currency;

/** Part of the charged amount that was not refunded yet (refunds that failed do not count). */
export const refundableOf = (payment: TPgPaymentDetails): number => {
	const charged = payment.chargedAmount ?? payment.totalAmount;
	const refunded = payment.refunds
		.filter((refund) => refund.status !== 'failed')
		.reduce((sum, refund) => sum + refund.amount, 0);
	return Math.max(0, roundTo(charged - refunded, 2));
};

/** An open dispute or a late failure that was not reversed: a refund may pay the money back twice. */
export const hasOpenDispute = (payment: TPgPaymentDetails): boolean => {
	const dispute =
		!!payment.disputeStatus &&
		!CLOSED_DISPUTE_STATUSES.includes(payment.disputeStatus.toUpperCase());
	const lateFailure = !!payment.lateFailureAt && !payment.lateFailureReversedAt;
	return dispute || lateFailure;
};

/** Purposes a refund can be made for (04 §14). */
export const isRefundablePurpose = (payment: TPgPaymentDetails): boolean =>
	payment.purpose === 'invoice' || payment.purpose === 'eu_ddp_prepayment';
